/* global $ */ // eslint-disable-line no-redeclare
/* eslint-disable */
import Sidebar from "@/components/Home_Sidebar/sidebarView.vue";
import Navbar from "@/components/Home_Navbar/NavbarView.vue";
import { get_token, getCookie } from "@/router/index.js";

export default {
  name: "SupersetAdminView",
  components: { Sidebar, Navbar },

  data: () => ({
    csrfToken: null,
    active_tab: "sync",

    loading_refresh: false,
    sync_user_loading: false,
    sync_all_loading: false,
    create_dashboard_loading: false,

    aic_users: [],
    superset_users: [],
    superset_roles: [],

    selected_user: null,

    sync_form: {
      superset_password: "",
      superset_roles: [],
    },

    sync_all_form: {
      superset_password: "",
      superset_roles: [],
    },

    dashboard_form: {
      dashboard_name: "",
      user_id: "",
    },
  }),

  computed: {
    loading_any() {
      return this.loading_refresh;
    },

    superset_emails_set() {
      const set = new Set();
      (this.superset_users || []).forEach((u) => {
        if (u?.email) set.add(String(u.email).toLowerCase());
      });
      return set;
    },

    synced_users() {
      return (this.aic_users || []).filter((u) => this.is_synced(u.email));
    },

    not_synced_users() {
      return (this.aic_users || []).filter((u) => !this.is_synced(u.email));
    },
  },

  mounted() {
    this.csrfToken = getCookie("csrftoken");
    this.refresh_all();
  },

  beforeUnmount() {
    this.destroy_data_table();
  },

  methods: {
    switch_tab(tab) {
      this.destroy_data_table();
      this.active_tab = tab;

      this.$nextTick(() => {
        if (this.active_tab === "sync") {
          this.initialize_data_table();
        }
      });
    },

    display_name(u) {
      if (!u) return "";
      const first = (u.first_name || "").trim();
      const last = (u.last_name || "").trim();
      const full = `${first} ${last}`.trim();
      return full || u.email || "—";
    },

    is_synced(email) {
      if (!email) return false;
      return this.superset_emails_set.has(String(email).toLowerCase());
    },

    async refresh_all() {
      this.loading_refresh = true;

      try {
        await Promise.all([
          this.get_aic_users(),
          this.get_superset_users(),
          this.get_superset_roles(),
        ]);

        this.$nextTick(() => {
          if (this.active_tab === "sync") {
            this.initialize_data_table();
          }
        });
      } finally {
        this.loading_refresh = false;
      }
    },

    async get_aic_users() {
      const token = get_token();
      if (!token) return this.$router.push({ name: "Login" });

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_all_users/`;

      const res = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
          "X-CSRFToken": this.csrfToken,
          "X-Page-URL": window.location.href,
        },
      });

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        this.$notyf?.error(data?.message || "Failed to fetch AIC One users");
        this.aic_users = [];
        return;
      }

      this.aic_users = Array.isArray(data?.data) ? data.data : [];
    },

    async get_superset_users() {
      const token = get_token();
      if (!token) return this.$router.push({ name: "Login" });

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/superset_management/api/get_superset_users_api/`;

      const res = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
          "X-CSRFToken": this.csrfToken,
          "X-Page-URL": window.location.href,
        },
      });

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        this.$notyf?.error(data?.message || "Failed to fetch Superset users");
        this.superset_users = [];
        return;
      }

      this.superset_users = Array.isArray(data?.data) ? data.data : [];
    },

    async get_superset_roles() {
      const token = get_token();
      if (!token) return this.$router.push({ name: "Login" });

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/superset_management/api/get_superset_roles_api/`;

      const res = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
          "X-CSRFToken": this.csrfToken,
          "X-Page-URL": window.location.href,
        },
      });

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        this.$notyf?.error(data?.message || "Failed to fetch Superset roles");
        this.superset_roles = [];
        return;
      }

      this.superset_roles = Array.isArray(data?.data) ? data.data : [];
    },

    destroy_data_table() {
      const table_el = $("#superset-users-table");
      if (table_el.length && $.fn.DataTable && $.fn.DataTable.isDataTable(table_el)) {
        table_el.DataTable().destroy();
      }
    },

    initialize_data_table() {
      if (this.loading_any) return;

      this.$nextTick(() => {
        const table_el = $("#superset-users-table");
        if (table_el.length && $.fn.DataTable) {
          if ($.fn.DataTable.isDataTable(table_el)) {
            table_el.DataTable().destroy();
          }
          table_el.DataTable({
            pageLength: 10,
            lengthChange: false,
            searching: true,
            ordering: true,
            paging: true,
            info: true,
            autoWidth: false,
          });
        }
      });
    },

    open_sync_modal(user) {
      this.selected_user = user;
      this.sync_form = { superset_password: "", superset_roles: [] };
      $("#sync_user_modal").modal("show");
    },

    async sync_selected_user() {
      if (!this.selected_user?.id) return;

      if (!this.sync_form.superset_password) {
        this.$notyf?.error("Superset password is required.");
        return;
      }

      const token = get_token();
      if (!token) return this.$router.push({ name: "Login" });

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/superset_management/admin_add_user_to_superset_api/`;

      this.sync_user_loading = true;

      try {
        const res = await fetch(url, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
            "X-CSRFToken": this.csrfToken,
            "X-Page-URL": window.location.href,
          },
          body: JSON.stringify({
            user_id: this.selected_user.id,
            superset_password: this.sync_form.superset_password,
            superset_roles: this.sync_form.superset_roles || [],
          }),
        });

        const data = await res.json().catch(() => null);

        if (!res.ok) {
          this.$notyf?.error(data?.message || "Failed to sync user to Superset");
          return;
        }

        this.$notyf?.success(data?.message || "User added to Superset");
        $("#sync_user_modal").modal("hide");

        await this.get_superset_users();


        this.destroy_data_table();
        this.initialize_data_table();
      } catch (e) {
        this.$notyf?.error("Sync failed");
      } finally {
        this.sync_user_loading = false;
      }
    },

    sync_all_open_modal() {
      this.sync_all_form = { superset_password: "", superset_roles: [] };
      $("#syncAllModal").modal("show");
    },

    async sync_all_users() {
      if (!this.sync_all_form.superset_password) {
        this.$notyf?.error("Default Superset password is required.");
        return;
      }

      const token = get_token();
      if (!token) return this.$router.push({ name: "Login" });

      const users_to_sync = [...this.not_synced_users];
      if (!users_to_sync.length) {
        this.$notyf?.info("No users to sync.");
        $("#syncAllModal").modal("hide");
        return;
      }

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/superset_management/admin_add_user_to_superset_api/`;

      this.sync_all_loading = true;

      try {
        let success_count = 0;
        let fail_count = 0;

        for (const u of users_to_sync) {
          try {
            const res = await fetch(url, {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
                "X-CSRFToken": this.csrfToken,
                "X-Page-URL": window.location.href,
              },
              body: JSON.stringify({
                user_id: u.id,
                superset_password: this.sync_all_form.superset_password,
                superset_roles: this.sync_all_form.superset_roles || [],
              }),
            });

            if (res.ok) success_count += 1;
            else fail_count += 1;
          } catch (e) {
            fail_count += 1;
          }
        }

        $("#syncAllModal").modal("hide");

        if (success_count) this.$notyf?.success(`${success_count} users synced successfully.`);
        if (fail_count) this.$notyf?.error(`${fail_count} users failed to sync.`);

        await this.get_superset_users();

        this.destroy_data_table();
        this.initialize_data_table();
      } finally {
        this.sync_all_loading = false;
      }
    },

    async create_dashboard() {
      this.$notyf?.info("Dashboard creation wiring can be enabled when needed.");
    },
  },
};
